module.exports = __webpack_public_path__ + "img/Den_Norske_Dictionarium_Primstav_Detalj.dd6d55ad.jpg";